/* eslint-disable react/no-typos */
import React from 'react'
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form, ListGroup } from 'react-bootstrap';
export const GridView = (props) =>{
    const { onSelect, listType, item, index, className } = props;
    return (
        <div 
            className={`${className} ${listType} ${item?.type} ${item.is_checked && "Selected"}`}
            onClick={() => onSelect(item, index)}
            key={index.toString()}
        >
            <ListGroup.Item
                key={index.toString()}
                action
                className=" gap-3 "
            >
                <img  className='img' src={item?.web_image_url} alt={item?.web_image_url} />
                <h5>{item.title}</h5>
                <Form.Check
                    name={item.title}
                    id={item.id}
                    type="checkbox"
                    checked={item.is_checked}
                    className={"CateSelection"}
                    readOnly
                />
            </ListGroup.Item>
        </div>
    )
}

export default function CategoryList(props) {
    const { type, className, onClear, title, listType, data } = props;
    const { t } = useTranslation();
  return (
    <React.Fragment>
        <ListGroup className={`${className} ${listType}`}>
            <React.Fragment>
                {title && <ListGroup.Item className="list-title d-flex align-center justify-content-between align-items-start">
                    <strong>{title}</strong>{" "}
                    <label
                        className="clear"
                        onClick={() => onClear()}
                    >
                        {t("pages.stores.clear")}
                    </label>
                </ListGroup.Item>}
                {data?.map((item, index) => (type !== "" && item.type === type) && (
                    <React.Fragment key={index.toString()}>
                    <GridView {...props} item={item} index={index} className={"list-collaps GridViewList"} />
                    </React.Fragment>
                ))}
                {type === "" && data?.map((item, index) => (
                    <React.Fragment key={index.toString()}>
                    <GridView {...props} item={item} index={index} className={"list-collaps GridViewList"} />
                    </React.Fragment>
                ))}
            </React.Fragment>
        </ListGroup>
    </React.Fragment>
  )
}
CategoryList.propTypes = {
    className: PropTypes.string,
    data:PropTypes?.array,
    onClear:PropTypes?.func,
    onSelect:PropTypes?.func,
    type:PropTypes?.any,
    listType:PropTypes?.string,
};
GridView.propTypes = {
    className: PropTypes.string,
    data:PropTypes?.array,
    onClear:PropTypes?.func,
    onSelect:PropTypes?.func,
    type:PropTypes?.any,
    listType:PropTypes?.string,
};